import { Site, Coordinates, BoundaryStyling, defaultCenter } from './LoadSiteData'
import yellowMarker from '../../assets/mapLocationMarkers/pinYellow.png';
import redMarker from '../../assets/mapLocationMarkers/pinRed.png';
import greyMarker from '../../assets/mapLocationMarkers/pinGrey.png';
import { APISiteLoggerDetail } from './LoadSiteDetailsData'
import React from 'react'
import type { google } from 'google.maps';
import { ColumnCellTemplateData } from 'devextreme/ui/data_grid';
import { Chip, useTheme, Tooltip } from '@mui/material';
import { IntlShape } from 'react-intl';
import { DataGridTypes } from "devextreme-react/data-grid"
export interface GPS {
    position: { lat: number, lng: number }
    icon: string
    serial: number
    loggerId: number
    tooltip: {deviceName: string | null}
    key: number
    defaultGps: boolean

}




export interface Name {
    siteNameTemp: string
    siteRefTemp: string
}










export const dataLoader = (
    site: Site,
    setPolygonPath: (path: Coordinates[]) => void,
    setHasBoundary: (bound: boolean) => void,
    setBoundaryStyle: (style: BoundaryStyling) => void,
    selectedLogger: number | null,
    unAssignedLoggers: Array<APISiteLoggerDetail>,
    setSelected: (selected: APISiteLoggerDetail[]) => void,
    handleAddDeviceClick: () => void,
    setMarkers: (markerData: GPS[]) => void,
    setTempName: ({ siteNameTemp, siteRefTemp }: { siteNameTemp : string, siteRefTemp: string }) => void,
    setSelectedCompany: (companyData: string | null) => void
): void => {
    console.log(site)
    let markersTemp: GPS[] | [] = []
    if (site.boundary) {
        const boundaryInfo = JSON.parse(site.boundary)

        if ((Array.isArray(boundaryInfo.path))) {
            setHasBoundary(true)
            setPolygonPath(boundaryInfo.path)
            setBoundaryStyle(boundaryInfo.styling)
        }
    } else {
        setPolygonPath([])
    }
    if (site.loggers.length > 0) {
        markersTemp = site && site.loggers.length > 0 ? site.loggers.map((logger: APISiteLoggerDetail) => {
            let hasNoGps = false
            console.log(logger)
            if (!logger.Latitude || !logger.Longitude) {
                logger.hasGps = false
            } else {
                logger.hasGps = true
            }

            let marker = yellowMarker
            if (!logger.Latitude && !logger.Longitude) {
                hasNoGps = true
                marker = redMarker
            }
            console.log(logger)
            return {

                position: hasNoGps ? { lat: defaultCenter.lat, lng: defaultCenter.lng } : { lat: logger.Latitude, lng: logger.Longitude },
                icon: marker,
                tooltip: {
                    deviceName: logger.DeviceName
                },
                serial: logger.Serial,
                loggerId: logger.LoggerId,
                key: logger.LoggerId,
                defaultGps: hasNoGps
            }
        })
        
            : []
        if (selectedLogger) {

            const loggerDetailSelected = unAssignedLoggers.filter(logger => logger.Serial === selectedLogger)[0]
            let hasNoGps = false
            if (!loggerDetailSelected.Latitude || !loggerDetailSelected.Longitude) {
                loggerDetailSelected.hasGps = false
            } else {
                loggerDetailSelected.hasGps = true
            }

            let marker = greyMarker
            if (!loggerDetailSelected.Latitude && !loggerDetailSelected.Longitude) {
                hasNoGps = true
                marker = redMarker
            }
            const selectedLoggerMarker = {
                position: hasNoGps ? { lat: defaultCenter.lat, lng: defaultCenter.lng } : { lat: loggerDetailSelected.Latitude, lng: loggerDetailSelected.Longitude },
                icon: marker,
                tooltip: {
                    deviceName: loggerDetailSelected.DeviceName
                },
                serial: loggerDetailSelected.Serial,
                loggerId: loggerDetailSelected.LoggerId,
                key: loggerDetailSelected.LoggerId,
                defaultGps: hasNoGps
            }
            markersTemp = [...markersTemp, selectedLoggerMarker]
            setSelected([loggerDetailSelected])

            handleAddDeviceClick()
        }

        setMarkers(markersTemp)

    } else if (selectedLogger && unAssignedLoggers.length > 0) {
        const loggerDetailSelected = unAssignedLoggers?.filter(logger => logger.Serial === selectedLogger)[0]
        let hasNoGps = false
        if (!loggerDetailSelected.Latitude || !loggerDetailSelected.Longitude) {
            loggerDetailSelected.hasGps = false
        } else {
            loggerDetailSelected.hasGps = true
        }

        let marker = greyMarker
        if (!loggerDetailSelected?.Latitude && !loggerDetailSelected?.Longitude) {
            hasNoGps = true
            marker = redMarker
        }

        const selectedLoggerMarker = {
            position: hasNoGps ? { lat: defaultCenter.lat, lng: defaultCenter.lng } : { lat: loggerDetailSelected.Latitude, lng: loggerDetailSelected.Longitude },
            icon: marker,
            tooltip: {
                deviceName: loggerDetailSelected.DeviceName
            },
            serial: loggerDetailSelected.Serial,
            loggerId: loggerDetailSelected.LoggerId,
            key: loggerDetailSelected.LoggerId,
            defaultGps: hasNoGps
        }
        markersTemp = [...markersTemp, selectedLoggerMarker]
        setSelected([loggerDetailSelected])

        setMarkers(markersTemp)
    }

    else {
        setMarkers([])
    }
    setTempName({ siteNameTemp: site.siteNameUserFriendly, siteRefTemp: site.siteName })
    setSelectedCompany(site.companyName)

} 

export const fitBoundsToMarkers = (
    mapRef: React.RefObject<google.maps.Map | null>,
    markers: GPS[],
    hasBoundary: boolean,
    createBoundary: boolean,
    polygonPath: Coordinates[]
): void => {
    if (mapRef.current && markers.length > 0) {
        const bounds = new window.google.maps.LatLngBounds();

        // Add all markers to bounds
        markers.forEach((marker: GPS) => {
            if (marker.position) {
                bounds.extend(marker.position);
            }
        });

        // Set polygon corners to the bounds so map zooms out to see full polygon path
        if (hasBoundary || createBoundary) {
            polygonPath.forEach((corner) => {
                console.log(corner);
                const latLng = new window.google.maps.LatLng(corner.lat, corner.lng);
                bounds.extend(latLng);
            });
        }
        mapRef.current.fitBounds(bounds);
    }
};

export const renderChip = (data: ColumnCellTemplateData, intl: IntlShape): React.ReactNode => {
    const theme = useTheme();
    return data.data.hasGps ? (
        <div style={{ float: "right" }}>
            <Chip
                sx={{ backgroundColor: theme.palette.grey.main, color: theme.palette.grey.contrastText }}
                label={data.value}
            />
        </div>

    ) : (
        <div style={{ color: theme.palette.error, display: "flex", justifyContent: "space-between" }}>

            <div>
                <Tooltip title={`${intl.formatMessage({ id: 'No Gps Location for Device: Will appear at default location' })} (${window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: 'Gutermann HQ' }) : intl.formatMessage({ id: 'Ashridge HQ' })}) `}>
                    <i className={"fa-solid fa-triangle-exclamation"} style={{ margin: "8px 0 0 0", position: "absolute" }}></i>
                </Tooltip>
            </div>
            <Chip color="error" label={data.value} />
        </div>
    );
};


export const handleRemoveDeviceChipAndMarker = (
    logger: GPS,
    markers: GPS[],
    selected: APISiteLoggerDetail[],
    site: Site,
    intl: IntlShape,
    handleLoggersToBeUnassigned: (logger: GPS) => void,
    setSelected: (data: APISiteLoggerDetail[]) => void,
    setMarkers: (data: GPS[]) => void,
    setPolygonPath: (data: Coordinates[] | []) => void,
    setHasBoundary: (data: boolean) => void,
    setCreateBoundary: (data: boolean) => void
):void => {

    let markersTemp = markers
    let selectedTemp = selected
    console.log(selected)
    if (site.loggers.filter(siteLogger => siteLogger.Serial === logger.serial)[0]) {
        const confirm = window.confirm(intl.formatMessage({ id: 'Are you sure you want to remove this assigned logger from this site? This logger will be removed when you click Save below' }))
        if (confirm) {
            markersTemp = markersTemp.filter(marker => marker.serial !== logger.serial)
            handleLoggersToBeUnassigned(logger)
        }
    } else {
        markersTemp = markersTemp.filter(marker => marker.serial !== logger.serial)
        selectedTemp = selectedTemp.filter(loggerSelected => loggerSelected.Serial !== logger.serial)
    }

    if (markersTemp.length === 0) {
        setPolygonPath([])
        setHasBoundary(false)
        setCreateBoundary(false)
    }

    setSelected(selectedTemp)
    setMarkers(markersTemp)
}

export const resetBoundaryAction = (
    reset: boolean,
    polygonPath: Coordinates[],
    markers: GPS[],
    setPolygonPath: (polygonPath: Coordinates[]) => void,
    setCenter: (data: Coordinates) => void
): void => {
    if (polygonPath.length === 0) {
        if (markers.length > 0) {
            const filterOutZeroValuesMarker = markers.filter(marker => marker.position.lat !== 0 && marker.position.lng !== 0)
            const avgLat = filterOutZeroValuesMarker.reduce((sum, marker) => sum + marker.position.lat, 0) / filterOutZeroValuesMarker.length;
            const avgLng = filterOutZeroValuesMarker.reduce((sum, marker) => sum + marker.position.lng, 0) / filterOutZeroValuesMarker.length;

            const polygonTemp = []
            polygonTemp.push(
                { lat: avgLat - 0.005, lng: avgLng + 0.005 },
                { lat: avgLat - 0.005, lng: avgLng - 0.005 },

                { lat: avgLat + 0.005, lng: avgLng - 0.005 },
                { lat: avgLat + 0.005, lng: avgLng + 0.005 }
            )
            setPolygonPath(polygonTemp)
            setCenter({ lat: avgLat, lng: avgLng });
        }
    }
}



export const selectionChanged = (
    data: unknown,
    markers: GPS[],
    setSelected: (keys) => void,
    setMarkers: (markersData: GPS[]) => void
): void => {
    let markersTemp = [...markers]
    if (data.currentSelectedRowKeys.length > 0) {
        data.currentSelectedRowKeys.forEach((device: APISiteLoggerDetail) => {
            let gpsData = false
            const loggerDetailSelected = device
            if (!loggerDetailSelected.Latitude || !loggerDetailSelected.Longitude) {
                loggerDetailSelected.Latitude = defaultCenter.lat
                loggerDetailSelected.Longitude = defaultCenter.lng
                gpsData = false
                loggerDetailSelected.hasGps = gpsData
            } else {
                gpsData = true
                loggerDetailSelected.hasGps = gpsData
            }
            if (gpsData) {

                markersTemp.push({ id: loggerDetailSelected.LoggerId, position: { lat: loggerDetailSelected.Latitude, lng: loggerDetailSelected.Longitude }, tooltip: { model: loggerDetailSelected.Model }, icon: greyMarker, serial: loggerDetailSelected.Serial, key: loggerDetailSelected.Serial })
            } else {
                markersTemp.push({ id: loggerDetailSelected.LoggerId, position: { lat: loggerDetailSelected.Latitude, lng: loggerDetailSelected.Longitude }, tooltip: { model: loggerDetailSelected.Model }, icon: redMarker, serial: loggerDetailSelected.Serial, key: loggerDetailSelected.Serial })
            }
        })
    } else {
        data.currentDeselectedRowKeys.forEach((device: APISiteLoggerDetail) => {
            const loggerDetailDeselected = device
            if (!loggerDetailDeselected.hasGps) {
                loggerDetailDeselected.Latitude = null
                loggerDetailDeselected.Longitude = null
            }
            markersTemp = markersTemp.filter(marker => marker.serial !== loggerDetailDeselected.Serial)
        })
    }


    setSelected(data.selectedRowKeys)
    setMarkers(markersTemp)

}


export const onMapLoad = (
    map: google.maps.Map,
    mapRef: React.RefObject<google.maps.Map | null>,
    markers: GPS[],
    hasBoundary: boolean,
    createBoundary: boolean,
    polygonPath: Coordinates[]
):void => {

    mapRef.current = map;
    map.setMapTypeId("hybrid")
    fitBoundsToMarkers(
        mapRef,
        markers,
        hasBoundary,
        createBoundary,
        polygonPath)

    if (!hasBoundary && markers.length === 1) {
        setTimeout(() => {
            mapRef.current.setZoom(18)
        }, 500)
    }
};

export const resetBoundary = (
    setHasBoundary: (boundary: boolean) => void,
    setPolygonPath: (polygon: Coordinates[] | []) => void,
    setBoundaryStyle: ({ strokeWeight, strokeColor, areaColor, transparency }: BoundaryStyling) => void,
    polygonPath: Coordinates[],
    markers: GPS[],
    setCenter: (data: Coordinates) => void 
): void => {
    setHasBoundary(false)
    setPolygonPath([])
    setBoundaryStyle({
        strokeWeight: 2,
        strokeColor: '#FF0000',
        areaColor: '#FF0000',
        transparency: 35
    })
    resetBoundaryAction(
        true,
        polygonPath,
        markers,
        setPolygonPath,
        setCenter
    )
}

